import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Always use the *English* MBTI keys for dynamic value lookup,
 * but allow trait labels to be translated.
 */
const DEFAULT_TRAIT_PAIRS = [
  ["INTROVERT", "EXTROVERT"],
  ["SENSING", "INTUITION"],
  ["THINKING", "FEELING"],
  ["JUDGING", "PROSPECTING"],
];

const MobProgressBar = ({ item }) => {
  const { t } = useTranslation("result");
  const getValues = (data1, data2) => {
    let colorClass, justify, largerPercentage, key, main_title;
    largerPercentage = data1.value > data2.value ? data1.value : data2.value;
    if (largerPercentage === data1.value) {
      justify = "justify-start";
      colorClass = "bg-green-500";
      key = data1.key
      main_title = data1.main_title
    } else if (largerPercentage === data2.value) {
      justify = "justify-end";
      colorClass = "bg-green-500";
      key = data2.key
      main_title = data2.main_title
    }
    return { colorClass, justify, largerPercentage, key, main_title };
  };
  
  // Get translated trait labels and main titles
  const mainTitles = t("tabSection.mainTitles", { returnObjects: true });
  const traitLabels = t("tabSection.traitLabels", { returnObjects: true });
  
  // Get trait labels - fallback to English keys if translation missing
  const getTraitLabel = (traitKey) => {
    if (traitLabels && traitLabels[traitKey]) {
      return traitLabels[traitKey];
    }
    // Final fallback to key itself
    return traitKey;
  };

  // Build transformed data using English keys for values but translated labels
  const transformedData = DEFAULT_TRAIT_PAIRS.map(([leftTrait, rightTrait], index) => {
    const leftValue = item?.prediction?.mbti?.values?.[leftTrait] || "0.0%";
    const rightValue = item?.prediction?.mbti?.values?.[rightTrait] || "0.0%";
    const mainTitle = Array.isArray(mainTitles) ? mainTitles[index] : (mainTitles || ["Energy", "Mind", "Nature", "Tactics"][index]);
    const mainTitleWithColon = `${mainTitle}:`;

    return [
      {
        key: getTraitLabel(leftTrait),
        value: leftValue,
        main_title: mainTitleWithColon,
      },
      {
        key: getTraitLabel(rightTrait),
        value: rightValue,
        main_title: mainTitleWithColon,
      },
    ];
  });
  return (
    <div className="bg-[#EDEDED] px-2 py-[2rem] lg:hidden md-max:hidden sm-max:block rounded-2xl mt-11">
      {transformedData?.map((item, index) => (
        <div key={index} className={`py-[1rem] px-[0rem]`}>
          <div className="w-full">
            <div className="flex items-center mb-3 "><p className="text-[#3976f9] text-xl font-semibold">{getValues(item[0], item[1]).main_title}&nbsp;</p><p className="text-xl font-semibold">{parseInt(getValues(item[0], item[1]).largerPercentage?.split('.')[0])}%&nbsp;</p><p className="text-xl font-semibold">{getValues(item[0], item[1]).key}</p></div>
            <div
              className={`w-full flex ${getValues(item[0], item[1]).justify
                } bg-[#D9D9D9] rounded-full`}
            >
              <div
                className={`rounded-full h-[10px] ${getValues(item[0], item[1]).colorClass
                  }`}
                style={{
                  width: `${getValues(item[0], item[1]).largerPercentage
                    }`,
                }}
              ></div>
            </div>

            <div className="flex justify-between mt-2">
              <div>
                <p className="text-xl">{parseInt(item[0].value?.split('.')[0])}%</p>
                <p className="text-xl" >{item[0].key}</p>
              </div>
              <div>
                <p className="text-right text-xl">{parseInt(item[1].value?.split('.')[0])}%</p>
                <p className="text-xl"> {item[1].key}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobProgressBar;
